import React from 'react';

function ExtraPricingPage() {
	return (
		<div>
			<ol className="breadcrumb">
							<li className="breadcrumb-item"><a href="#/">Home</a></li>
							<li className="breadcrumb-item"><a href="#/">Pages</a></li>
							<li className="breadcrumb-item active"></li>
						</ol>
						
						
						<h1 className="page-header">Pricing Page <small>page header description goes here...</small></h1>
						
						
						<div className="card border-0 theme-gray-600 rounded-4 overflow-hidden" data-bs-theme="dark">
							<div className="row gx-0">
								<div className="col-xl-7 position-relative">
									<div className="p-5">
										<div className="display-5 fw-bold mb-3 text-white">Web Hosting Plan</div>
										<div className="mb-4 font-monospace">
											Discover the <b className="text-white d-inline-flex border-bottom border-1 border-gray-500">perfect plan</b> for your online presence. In a digital landscape where your website is the gateway to your brand, we offer an array of meticulously crafted hosting plans to suit every ambition and requirement.
										</div>
										<div className="row mb-n3">
											<div className="col-md-6">
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:cup-star-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														Robust Performance
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:cpu-bolt-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														Scalability Options
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:shield-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														Security First
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:headphones-round-sound-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														24/7 Support
													</div>
												</div>
											</div>
											<div className="col-md-6">
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:monitor-smartphone-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														User-Friendly Control Panel
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:mouse-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														One-Click Installations
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:gift-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														Value-Added Features
													</div>
												</div>
												<div className="d-flex align-items-center mb-3">
													<iconify-icon className="fs-1 text-theme" icon="solar:dollar-bold-duotone"></iconify-icon>
													<div className="flex-1 ps-2 fs-13px fw-bold">
														Money-Back Guarantee
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xl-5 d-xl-block d-none">
									<div className="ms-n5 h-100 d-flex align-items-center justify-content-end">
										<img src="/color-admin/admin/react/assets/img/pricing/img-1.svg" style={{ height: '110%' }} alt="" />
									</div>
								</div>
							</div>
						</div>
						
						<div className="row gy-3 gx-lg-4 py-lg-5 py-3" data-bs-theme="dark">
							<div className="col-xl-3 col-md-6 py-lg-3 py-xl-5">
								<div className="card border-0 rounded-4 h-100">
									<div className="card-body p-4 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="fs-5 fw-bold font-monospace text-white mb-1">Starter Plan</div>
												<div className="display-6 fw-bold text-white">$5 <small className="fs-6 text-white text-opacity-50">/month*</small></div>
											</div>
											<div>
												<iconify-icon className="display-4 text-theme" icon="solar:usb-bold-duotone"></iconify-icon>
											</div>
										</div>
										<hr className="my-4 mx-n4" />
										<div className="mb-4 text-body text-opacity-75 flex-1 d-flex flex-column gap-2">
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Storage:</span> <b className="text-white">10 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Bandwidth:</span> <b className="text-white">100 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Domain Names:</span> <b className="text-white">1</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">SSL Certificate:</span> <b className="text-white"> Shared</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Email Accounts:</span> <b className="text-white"> 5</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">24/7 Support:</span> <b className="text-white"> Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Backup:</span> <b className="text-white"> Daily</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-white"> 99.9%</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">FTP Access:</span> <b className="text-white"> Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Control Panel:</span> <b className="text-white"> cPanel</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Free Domain:</span> <b className="text-white"> No</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Firewall:</span> <b className="text-white"> No</b></div>
											</div>
										</div>
										<div>
											<a href="#/" className="btn btn-default btn-lg w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-md-6 py-lg-3 py-xl-5">
								<div className="card border-0 rounded-4 h-100">
									<div className="card-body p-4 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="fs-5 fw-bold font-monospace text-white mb-1">Booster Plan</div>
												<div className="display-6 fw-bold text-white">$10 <small className="fs-6 text-white text-opacity-50">/month*</small></div>
											</div>
											<div>
												<iconify-icon className="display-4 text-theme" icon="solar:map-arrow-up-bold-duotone"></iconify-icon>
											</div>
										</div>
										<hr className="my-4 mx-n4" />
										<div className="mb-4 text-body text-opacity-75 flex-1 d-flex flex-column gap-2">
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Storage:</span> <b className="text-white">20 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Bandwidth:</span> <b className="text-white">200 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Domain Names:</span> <b className="text-white">2</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">SSL Certificate:</span> <b className="text-white"> Free</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Email Accounts:</span> <b className="text-white"> 10</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">24/7 Support:</span> <b className="text-white"> Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Backup:</span> <b className="text-white"> Daily</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-white"> 99.9%</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">FTP Access:</span> <b className="text-white"> Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Control Panel:</span> <b className="text-white"> cPanel</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Free Domain:</span> <b className="text-white"> No</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Firewall:</span> <b className="text-white"> No</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
											</div>
										</div>
										<div>
											<a href="#/" className="btn btn-default btn-lg w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3 col-md-6 py-lg-3 py-xl-0">
								<div className="card border-0 rounded-4 shadow-lg bg-theme-gradient text-white h-100 overflow-hidden">
									<div className="card-body p-4 h-100 d-flex flex-column z-3">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="h5 font-monospace">Premium Plan</div>
												<div className="display-6 fw-bold mb-0">$15 <small className="h5 text-body text-opacity-50">/month*</small></div>
											</div>
											<div>
												<iconify-icon className="display-3 text-white" icon="solar:cup-first-bold-duotone"></iconify-icon>
											</div>
										</div>
										<hr className="my-4 mx-n4" />
										<div className="mb-5 text-body text-opacity-75 flex-1 d-flex flex-column gap-2">
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Storage:</span> <b className="text-white">50 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Bandwidth:</span> <b className="text-white">500 GB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Domain Names:</span> <b className="text-white">Unlimited</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">SSL Certificate:</span> <b className="text-white">Free</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Email Accounts:</span> <b className="text-white">Unlimited</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">24/7 Support:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Backup:</span> <b className="text-white">Daily</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-white">99.9%</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">FTP Access:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Control Panel:</span> <b className="text-white">cPanel</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Free Domain:</span> <b className="text-white">No</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Firewall:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">E-commerce Support</span></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-white text-opacity-50 fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
											</div>
										</div>
										<a href="#/" className="btn btn-light btn-lg w-100 text-black font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
									</div>
									<div className="position-absolute top-0 start-0 w-100 h-100 bg-black bg-opacity-25 z-2"></div>
								</div>
							</div>
							<div className="col-xl-3 col-md-6 py-lg-3 py-xl-5">
								<div className="card border-0 rounded-4 h-100">
									<div className="card-body p-4 d-flex flex-column">
										<div className="d-flex align-items-center">
											<div className="flex-1">
												<div className="fs-5 fw-bold font-monospace text-white mb-1">Business Plan</div>
												<div className="display-6 fw-bold text-white">$99 <small className="fs-6 text-white text-opacity-50">/month*</small></div>
											</div>
											<div>
												<iconify-icon className="display-4 text-theme" icon="solar:buildings-bold-duotone"></iconify-icon>
											</div>
										</div>
										<hr className="my-4 mx-n4" />
										<div className="mb-5 text-body text-opacity-75 flex-1 d-flex flex-column gap-2">
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Storage:</span> <b className="text-white">1 TB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Bandwidth:</span> <b className="text-white">20 TB</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Domain Names:</span> <b className="text-white">Unlimited</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">SSL Certificate:</span> <b className="text-white">Free</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Email Accounts:</span> <b className="text-white">Unlimited</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check fa-lg text-theme"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">24/7 Support:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Backup:</span> <b className="text-white"> Daily</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-white">99.9%</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">FTP Access:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Control Panel:</span> <b className="text-white">cPanel</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Free Domain:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">Firewall:</span> <b className="text-white">Yes</b></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">E-commerce Support</span></div>
											</div>
											<div className="d-flex align-items-center">
												<i className="fa fa-check text-theme fa-lg"></i> 
												<div className="flex-1 ps-3 d-flex align-items-end gap-2"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
											</div>
										</div>
										<div>
											<a href="#/" className="btn btn-default btn-lg w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
										</div>
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraPricingPage;
